import {
  Box,
  Heading,
  Flex,
  Link,
  Image,
  Text,
  Input,
  Button,
} from "@chakra-ui/react"
import React, { useState } from "react"
import YouTube from "../video/YoutubeEmbed"
import { LogoCarousel } from "../slider/LogoCarousel"

import { colors } from "../colors/colors"
import { SEO } from "../seo/SEO"
import { Logo } from "../logo/Logo"
import Ribbon from "./ribbon_bg.png"
import GetApp from "./get_app@2x.jpg"
import GetMojo from "./getmojo_img.jpg"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"

export function SmsLander({
  pageBuilderData,
  goalName,
  title,
  description,
  getAppView = false,
}) {
  const [phone, setPhone] = useState("")
  const [success, setSuccess] = useState("")

  return (
    <Box>
      <Flex position="relative">
        <SEO title="Get the App!" />

        <Box
          flex={"0 0 50%"}
          bg="white"
          height="100vh"
          display={{ base: `none`, md: `block` }}
        ></Box>
        {!getAppView && (
          <Box
            flex={"0 0 50%"}
            bg={colors.blue}
            height="100vh"
            bgImage={`url("${Ribbon}")`}
            backgroundRepeat="no-repeat"
            backgroundPosition="right top"
            backgroundSize="contain"
            display={{ base: `none`, md: `initial` }}
          ></Box>
        )}

        <Box
          position={{ base: `relative`, md: "absolute" }}
          width="100%"
          height="100%"
          bg={{ base: "white", md: `transparent` }}
          top="0px"
          zIndex={3}
        >
          <Box display={{ base: `block`, md: `none` }} m="0 auto" maxW="375px">
            <Image src={GetApp} ignoreFallback maxW="100%" maxH="240px" />
          </Box>
          <Box
            maxW={{ base: `375px`, md: "1280px" }}
            m="0 auto"
            p={{ base: "0 20px", xl: `0` }}
          >
            <Flex>
              <Box flex="1 0 0px" p={{ base: "21px 0 80px", md: "80px 0" }}>
                <Logo width={`160px`} />

                <Heading
                  color="black"
                  textTransform="uppercase"
                  mt={{ base: `20px`, md: "30px" }}
                  fontSize={{ base: `40px`, md: `48px` }}
                  letterSpacing="-0.8px"
                  lineHeight={{ base: `52px`, md: "60px" }}
                  fontWeight="600"
                >
                  {title || `coaching made easy`}
                </Heading>

                <Text
                  color="#8E8E93"
                  fontSize={{ base: `16px`, md: "18px" }}
                  line-height="26px"
                  maxW="420px"
                >
                  {description ||
                    `The MOJO app is the best youth sports coaching resource for
                  kids, parents, coaches, and families everywhere. Try MOJO
                  today.`}
                </Text>

                <Box m={{ base: `20px 0`, md: "30px 0 40px" }}>
                  <Flex display={{ base: `flex`, md: `none` }}>
                    <Box flex="0 0 200px">
                      <Link
                        textTransform="uppercase"
                        href="https://yougotmojo.app.link/getmojo?~campaign=gettheapp&~channel=mojosport&~feature=website"
                        target="_blank"
                      >
                        <Button
                          borderRadius="0px"
                          width="100%"
                          _hover={{
                            backgroundColor: `white`,
                            color: colors.blue,
                          }}
                          fontFamily="Teko"
                          fontSize="21.6px"
                          height="54px"
                          color="white"
                          bg={colors.blue}
                          type="button"
                        >
                          GET THE APP
                        </Button>
                      </Link>
                    </Box>
                  </Flex>
                  <Flex display={{ base: `none`, md: `flex` }}>
                    <Box flex="0 0 240px">
                      <Input
                        type="tel"
                        border="1px solid #D1D1D6"
                        borderRadius="0px"
                        borderColor="#D1D1D6"
                        background="white"
                        fontSize="21.6px"
                        color="#AEAEB2"
                        textAlign="center"
                        _placeholder={{
                          fontSize: "21.6px",
                          color: "#AEAEB2",
                          letterSpacing: "0.2px",
                          textAlign: "center",
                          fontFamily: "Teko",
                        }}
                        height="54px"
                        value={phone}
                        onChange={evt => {
                          setPhone(evt.currentTarget.value)
                        }}
                        placeholder="MOBILE NUMBER"
                      />
                    </Box>
                    <Box flex="0 0 160px">
                      <Button
                        borderRadius="0px"
                        width="100%"
                        fontFamily="Teko"
                        fontSize="21.6px"
                        height="54px"
                        color="white"
                        bg={colors.blue}
                        type="button"
                        onClick={() => {
                          if (typeof window !== `undefined`) {
                            const windowOb = window as any

                            if (windowOb?.branch) {
                              console.log("Calling Branch SMS for", phone)
                              windowOb?.branch.sendSMS(
                                phone,
                                {
                                  channel: "Website",
                                  feature: "website",
                                },
                                { make_new_link: true },
                                function (err) {
                                  console.log("SMS Result", err)

                                  if (!err) {
                                    trackCustomEvent({
                                      category: `Goal`,
                                      action: `Submit`,
                                      label: goalName,
                                      value: 1,
                                    })

                                    setSuccess(
                                      "You should receive a text to download the app."
                                    )
                                    setPhone("")
                                  } else {
                                    setSuccess(err.message)
                                    setPhone("")
                                  }
                                }
                              )
                            }
                          }
                        }}
                      >
                        SEND ME THE APP
                      </Button>
                    </Box>
                  </Flex>
                </Box>

                <Box
                  textAlign="left"
                  maxWidth={{ base: `100%`, md: `500px` }}
                  m={{ base: "20px 0", md: "30px 0" }}
                >
                  <Text
                    color="#8E8E93"
                    fontSize="18px"
                    line-height="26px"
                    maxW="420px"
                  >
                    Available for iOS and Android devices
                  </Text>

                  {success && (
                    <Text
                      mt="10px"
                      fontSize="16px"
                      textAlign="left"
                      color={colors.blue}
                    >
                      {success}
                    </Text>
                  )}
                </Box>

                <Box
                  textAlign="left"
                  maxWidth={{ base: `320px`, md: `500px` }}
                  m={{ base: "0", md: "30px 0" }}
                  display={{ base: `block`, md: `none` }}
                >
                  {pageBuilderData &&
                    pageBuilderData.map(
                      ({ fieldGroupName, ...rest }, index) => {
                        if (
                          fieldGroupName ===
                          `page_Pagebuilderdata_PageBuilder_LogoCarousel`
                        ) {
                          return (
                            <LogoCarousel
                              hideCta
                              key={`fieldGroupName_${fieldGroupName}_${index}`}
                              {...rest}
                            />
                          )
                        }
                      }
                    )}
                </Box>

                <Box mb="42px" textAlign={{ base: `center`, md: `left` }}>
                  <Link
                    fontSize="16px"
                    color="#0099FF"
                    lineHeight="26px"
                    fontWeight="bold"
                    textTransform="uppercase"
                    href="https://mojo.sport"
                  >
                    Learn More
                  </Link>
                </Box>

                <Box textAlign="center" display={{ base: `block`, md: `none` }}>
                  <Text fontSize="14px" color="#8E8E93" lineHeight="40px">
                    <Link href="/terms">Terms of Use</Link>
                    <Text as="span" color="#8E8E93" paddingX="8px">
                      &nbsp;|&nbsp;
                    </Text>
                    <Link href="/privacy">Privacy Policy</Link>
                  </Text>
                  <Text fontSize="14px" color="#8E8E93" lineHeight="40px">
                    © Copyright 2021 MOJO Inc.
                  </Text>
                </Box>

                <Text
                  color="#8E8E93"
                  fontSize="18px"
                  line-height="26px"
                  maxW="420px"
                  display={{ base: `none`, md: `block` }}
                >
                  By providing your phone number, you agree to receive a
                  one-time automated text message with a link to get the app.
                  Standard messaging rates may apply.
                </Text>
              </Box>

              <Box
                flex="1 0 0px"
                p="80px 0 0 160px"
                alignSelf="center"
                display={{ base: `none`, md: `block` }}
              >
                {getAppView ? (
                  <Image src={GetMojo} ignoreFallback maxW="100%" />
                ) : (
                  <YouTube
                    id="-SBh5saE_BM"
                    opts={{
                      width: `100%`,
                    }}
                  />
                )}
              </Box>
            </Flex>
          </Box>
        </Box>
      </Flex>
    </Box>
  )
}
